import { render, staticRenderFns } from "./VideoInfo.vue?vue&type=template&id=2cd5486b&"
import script from "./VideoInfo.vue?vue&type=script&lang=js&"
export * from "./VideoInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports